import setupAxiosInterceptors from './api/interceptor';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import { useEffect, useContext } from 'react';
import { AuthContext } from './context/AuthContext';
import * as AppUrls from './common/AppUrls';

import MainLayout from './components/MainLayout';

import publicRoutes from "./app/router/PublicRoutes";



import DashboardLayout from './components/DashboardLayout';
import DashOverview from './pages/private/DashOverview';
import Schedule from './pages/private/Schedule';
import RoomTypes from './pages/private/RoomTypes';
import Rooms from './pages/private/Rooms';
import SubjectComponentTypes from './pages/private/SubjectComponentTypes';
import Subjects from './pages/private/Subjects';
import ElectiveSubjects from './pages/private/ElectiveSubjects';
import Teachers from './pages/private/Teachers';
import Students from './pages/private/Students';
import SubjectClass from './pages/private/SubjectClass';
import RealStudents from './pages/private/RealStudents';
import StaffAbsence from './pages/private/StaffAbsence';
import StaffAttendance from './pages/private/StaffAttendance';
import StaffSubstitute from './pages/private/StaffSubstitute';
import Preferences from './pages/private/Preferences';
import Profile from './pages/private/Profile';
import Account from './pages/private/Account';
import ManageSubscription from './pages/private/ManageSubscription';
import CreateSchedule from './pages/private/CreateSchedule';
import Trainers from './pages/private/Trainers';
import Members from './pages/private/Members';
import FitnessPayments from './pages/private/FitnessPayments';

import DocsLayout from './components/DocsLayout';
import DocsHome from './pages/public/docs/DocsHome';
import DocsGettingStarted from './pages/public/docs/DocsGettingStarted';
import DocsRoomTypes from './pages/public/docs/DocsRoomTypes';
import DocsRooms from './pages/public/docs/DocsRooms';
import DocsSubjects from './pages/public/docs/DocsSubjects';
import DocsTeachers from './pages/public/docs/DocsTeachers';
import DocsStudents from './pages/public/docs/DocsStudents';
import DocsPreferences from './pages/public/docs/DocsPreferences';
import DocsSchedule from './pages/public/docs/DocsSchedule';
import DocsScheduleCreate from './pages/public/docs/DocsScheduleCreate';

import NoPage from './pages/public/NoPage';

function App() {
  const { refreshToken } = useContext(AuthContext);

  useEffect(() => {
    setupAxiosInterceptors(refreshToken);
  }, []);

  return (
    <Box>
      <BrowserRouter>
        <Routes>
          <Route element={<MainLayout />}>
            {/* Public Pages (Always Accessible) */}
            {publicRoutes}

            {/* Public Pages - Docs */}
            {/* Update in DocsLayout.js */}
            <Route path="/docs/*" element={<DocsLayout />}>
              <Route index element={<Navigate to="overview" />} />
              <Route path="overview" element={<DocsHome />} />
              <Route path="getting-started" element={<DocsGettingStarted />} />
              <Route path="classroom-types" element={<DocsRoomTypes />} />
              <Route path="classrooms" element={<DocsRooms />} />
              <Route path="subjects" element={<DocsSubjects />} />
              <Route path="teachers" element={<DocsTeachers />} />
              <Route path="students" element={<DocsStudents />} />
              <Route path="configuration" element={<DocsPreferences />} />
              <Route path="create-timetable" element={<DocsScheduleCreate />} />
              <Route path="view-timetable" element={<DocsSchedule />} />
              <Route path="*" element={<NoPage redirectUrl='/docs'/>} />
            </Route>

            {/* Private Routes (Require Login) */}
            <Route path={AppUrls.DASHBOARD_URL_PREFIX} element={<DashboardLayout />}>
              <Route index element={<Navigate to={AppUrls.DASHBOARD_URL_REL} />} />
              <Route path={AppUrls.DASHBOARD_URL_REL} element={<DashOverview />} />
              <Route path={AppUrls.TIME_TABLE_URL_REL} element={<Schedule />} />
              <Route path="classroom-types" element={<RoomTypes />} />
              <Route path={AppUrls.CLASSROOM_URL_REL} element={<Rooms />} />
              <Route path="subject-component-types" element={<SubjectComponentTypes />} />
              <Route path={AppUrls.SUBJECT_URL_REL} element={<Subjects />} />
              {/* <Route path={AppUrls.ELECTIVE_SUBJECT_URL_REL} element={<ElectiveSubjects />} /> */}
              <Route path={AppUrls.TEACHER_URL_REL} element={<Teachers />} />
              <Route path={AppUrls.SECTION_URL_REL} element={<Students />} />
              {/* <Route path="students" element={<RealStudents />} /> */}
              <Route path={AppUrls.SUBJECT_CLASS_URL_REL} element={<SubjectClass />} />
              {/* Staff Absence tab is hidden, the daily attendance flow replaces it. Route kept for old links */}
              <Route path={AppUrls.STAFF_ABSENCE_URL_REL} element={<StaffAbsence />} />
              <Route path={AppUrls.STAFF_ATTENDANCE_URL_REL} element={<StaffAttendance />} />
              <Route path={AppUrls.STAFF_SUBSTITUTE_URL_REL} element={<StaffSubstitute />} />
              <Route path={AppUrls.TEMPLATE_URL_REL} element={<Preferences />} />
              <Route path={AppUrls.CREATE_TIME_TABLE_URL_REL} element={<CreateSchedule />} />
              <Route path={AppUrls.TRAINER_URL_REL} element={<Trainers />} />
              <Route path={AppUrls.MEMBER_URL_REL} element={<Members />} />
              <Route path={AppUrls.FITNESS_PAYMENT_URL_REL} element={<FitnessPayments />} />
              <Route path={AppUrls.ACCOUNT_URL_REL} element={<Account />} />
              <Route path={AppUrls.PROFILE_URL_REL} element={<Profile />} />
              <Route path={AppUrls.MANAGE_SUBSCRIPTION_URL_REL} element={<ManageSubscription />} />
              <Route path="*" element={<NoPage redirectUrl={AppUrls.DASHBOARD_URL}/>} />
            </Route>
          </Route>

          {/* Catch-All for 404 */}
          <Route path="*" element={<NoPage />} />
        </Routes>
      </BrowserRouter>
    </Box>
  );
}

export default App;
